import { FC } from 'react';
import { Check } from 'lucide-react';
import { SelfAssessSummary } from '@new/features/courses/utils/selfAssessHelpers';

interface StudentCourseSelfAssessProps {
  summary: SelfAssessSummary;
}

export const StudentCourseSelfAssess: FC<StudentCourseSelfAssessProps> = ({ summary }) => {
  const { completedObjectivesCount, totalObjectivesCount, remainingObjectivesCount } = summary;

  const hasObjectiveData = totalObjectivesCount > 0;

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-(--neutral-white-NW800) bg-(--neutral-white-NW1000) p-4 shadow-sm">
      <div className="flex items-center justify-start gap-3">
        <div className="flex size-8 shrink-0 items-center justify-center rounded-full bg-(--primary-O200)">
          <Check className="size-4 text-(--primary-O800)" strokeWidth={3} />
        </div>

        <div className="flex min-w-0 flex-col gap-2">
          <h6 className="[font-size:var(--fs-h6)] [font-family:var(--font-montserrat)]! m-0! font-semibold! leading-tight text-(--neutral-black-NB800)!">
            Self-assess
          </h6>

          <div className="flex flex-wrap items-center gap-2">
            <p className="[font-size:var(--fs-l4)] m-0! font-medium leading-tight text-(--neutral-black-NB700)">
              {hasObjectiveData
                ? `${completedObjectivesCount}/${totalObjectivesCount} objectives completed`
                : 'Objective progress is not available yet'}
            </p>

            {hasObjectiveData && (
              <>
                <div className="size-1 rounded-full bg-(--neutral-black-NB700)" />

                <p className="[font-size:var(--fs-l4)] m-0! font-medium leading-tight text-(--neutral-black-NB700)">
                  {remainingObjectivesCount} remaining
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
